import { useEffect, useState } from 'react'
import hamburger from "../../assets/images/hamburger.svg"
const UserAvatar = () => {
  const [username, setUsername] = useState('')
  const [avatar, setAvatar] = useState('')

  const toggleSideBar = (event) => {
    if (Array.from(document.getElementById('hamburger').classList).includes('open')) {
      document.getElementById('sideBar').className ="flex-none w-80 bg-[#F4F9F9] h-screen px-8 py-6 pt-20 fixed right-0 top-0 z-0 overflow-y-auto no-scrollbar ease-in-out duration-300 translate-x-auto"
      document.getElementById('hamburger').classList.remove("open")
      document.getElementById('hamburger').classList.add("close")
    }
    else {
      document.getElementById('sideBar').className ="hidden flex-none w-80 bg-[#F4F9F9] h-screen px-8 py-6 pt-20 sticky top-0 z-0 overflow-y-auto no-scrollbar md:block  ease-in-out duration-300 translate-x-0"
      document.getElementById('hamburger').classList.remove("close")
      document.getElementById('hamburger').classList.add("open")
    }
  }

  useEffect(() => {
    if(localStorage.getItem('user') === null) return
    const { username, avatar } = JSON.parse(localStorage.getItem('user'))
    setUsername(username)
    setAvatar(avatar)
  }, [])

  return (
    <div className="flex items-center">
      <span className="mr-3 text-primary text-sm font-medium">{username}</span>
      <img src={avatar} alt="avatar" className="h-8 w-8 rounded-full" />
      <img id="hamburger" onClick={(e) => toggleSideBar(e)} src={hamburger} alt="hamburger" className="ml-4 h-7 w-7 md:hidden open" />
    </div>
  )
}

export default UserAvatar
